import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CapacityPlanRunQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type CapacityPlanRunQuery = { __typename?: 'Query', capacityPlanRun: { __typename?: 'CapacityPlanRun', id: any, agencyId?: any | null, agencyName?: string | null, isNetworkRun: boolean, label?: string | null, createdBy?: string | null, createdAt: any, fileName?: string | null, status: Types.CapacityPlanRunStatus, queuedAt?: any | null, computingStartedAt?: any | null, geocodeRequestedAt?: any | null, computedAt?: any | null, driverCount?: number | null, error?: string | null, warnings: Array<string>, totalDeliveries: number, geocodedDeliveries: number, validDeliveries: number, invalidDeliveries: number, pendingGeocodes: number, failedGeocodes: number, approximatedGeocodes: number, missingCoordinates: number, outOfCountryDeliveries: number, settings: { __typename?: 'CapacityPlanRunSettings', depotLatitude?: number | null, depotLongitude?: number | null, capacity?: number | null, shiftStart: string, shiftEnd: string, breaks: Array<{ __typename?: 'CapacityPlanBreak', windowStart: string, windowEnd: string, durationSeconds: number }> }, solveProgress: { __typename?: 'CapacityPlanSolveProgress', total: number, queued: number, computing: number, computed: number, failed: number }, depots: Array<{ __typename?: 'CapacityPlanDepotSummary', agencyName?: string | null, depotIndex: number, latitude: number, longitude: number, solves: number, failedSolves: number, deliveries: number, failedDeliveries: number, recipients: number, stops: number, drivers: number, routedRecipients: number, unassignedStops: number, unassignedDeliveries: number }>, totals?: { __typename?: 'CapacityPlanRunTotals', depots: number, solves: number, failedSolves: number, deliveries: number, recipients: number, stops: number, drivers: number, routedRecipients: number, unassignedStops: number, unassignedDeliveries: number } | null } };


export const CapacityPlanRunDocument = gql`
    query CapacityPlanRun($id: ID!) {
  capacityPlanRun(id: $id) {
    id
    agencyId
    agencyName
    isNetworkRun
    label
    createdBy
    createdAt
    fileName
    status
    queuedAt
    computingStartedAt
    geocodeRequestedAt
    computedAt
    driverCount
    error
    warnings
    totalDeliveries
    geocodedDeliveries
    validDeliveries
    invalidDeliveries
    pendingGeocodes
    failedGeocodes
    approximatedGeocodes
    missingCoordinates
    outOfCountryDeliveries
    settings {
      depotLatitude
      depotLongitude
      capacity
      shiftStart
      shiftEnd
      breaks {
        windowStart
        windowEnd
        durationSeconds
      }
    }
    solveProgress {
      total
      queued
      computing
      computed
      failed
    }
    depots {
      agencyName
      depotIndex
      latitude
      longitude
      solves
      failedSolves
      deliveries
      failedDeliveries
      recipients
      stops
      drivers
      routedRecipients
      unassignedStops
      unassignedDeliveries
    }
    totals {
      depots
      solves
      failedSolves
      deliveries
      recipients
      stops
      drivers
      routedRecipients
      unassignedStops
      unassignedDeliveries
    }
  }
}
    `;

/**
 * __useCapacityPlanRunQuery__
 *
 * To run a query within a React component, call `useCapacityPlanRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapacityPlanRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapacityPlanRunQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCapacityPlanRunQuery(baseOptions: Apollo.QueryHookOptions<CapacityPlanRunQuery, CapacityPlanRunQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CapacityPlanRunQuery, CapacityPlanRunQueryVariables>(CapacityPlanRunDocument, options);
      }
export function useCapacityPlanRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CapacityPlanRunQuery, CapacityPlanRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CapacityPlanRunQuery, CapacityPlanRunQueryVariables>(CapacityPlanRunDocument, options);
        }
export type CapacityPlanRunQueryHookResult = ReturnType<typeof useCapacityPlanRunQuery>;
export type CapacityPlanRunLazyQueryHookResult = ReturnType<typeof useCapacityPlanRunLazyQuery>;
export type CapacityPlanRunQueryResult = Apollo.QueryResult<CapacityPlanRunQuery, CapacityPlanRunQueryVariables>;